import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { VaultStoreEffects } from './effects';
import { VaultReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('Vault', VaultReducer), EffectsModule.forFeature([VaultStoreEffects])],
  providers: [VaultStoreEffects]
})
export class VaultStoreModule {}
